import './constants.credit-card';
import './services.logger';
import { getSLPaymentGatewayService } from '../../service/slPaymentGatewayService';

app.directive('checkoutShoplinePaymentGateway', [
  'logger',
  'cart',
  function (logger, cart) {
    return {
      restrict: 'A',
      scope: {
        onSdkInit: '&',
      },
      link: function (scope) {
        try {
          const slPaymentGatewayService = getSLPaymentGatewayService();
          const paymentGatewayConfig =
            slPaymentGatewayService.getDefaultPaymentConfig(
              cart.payment_method,
            );

          const renderSDK = (paymentConfig) => {
            slPaymentGatewayService
              .renderSDK({
                paymentConfig,
                elementId: '#checkout-shopline-payment-gateway-form',
              })
              .then((data) => {
                scope.onSdkInit({ value: data });
              })
              .catch((error) => {
                logger.error('renderGatewaySDKError:', error.message);
              });
          };

          renderSDK(paymentGatewayConfig);
        } catch (e) {
          logger.error(e);
        }
      },
    };
  },
]);
